export default {
    // The key format should be: 'locale.filename'.
    'uk.admin': require('../../../lang/uk/admin.php'),
}
